// extracted by css-extract-rspack-plugin
export default {"checkboxradio":"CheckboxRadio_checkboxradio__B2kMi"};